@if (!walletLoader) {
  <section class="mt-4 px-3">
    <div class="container-fluid">
      <h1 class="heading-wallet mb-3" i18n="@@wallet-management">
        CargoWALLET Management
      </h1>
      @if (!showActivationForm) {
        <span class="sub-heading" i18n="@@wallet.my-office-wallet"
          >My Office Wallet</span
        >
      }
      @if (!showActivationForm) {
        <div class="row wallet-main">
          <div
            class="col-lg-4 col-md-12 col-12"
            [class.no-view-balance]="!canViewBalance"
          >
            <kt-wallet-status
              [title]="'PREPAID BALANCE'"
              [description]="walletStatusDescription"
              [tag]="'PREPAID'"
              [status]="walletStatus"
              titleToolTipMessage="The ''Prepaid Balance'' corresponds to the available funds that you have top up on your CargoWallet"
              titleToolTipPlacement="left-start"
              [showActivateButton]="true"
              [showAdditionalButton]="true"
              [showStatus]="true"
              [selectedOffice]="selectedOffice"
              [canViewBalance]="canViewBalance"
              [walletDetails]="walletDetails"
              [showAddWalletButton]="true"
              [isPageReady]="isPageReady"
              (showWalletActivationForm)="showWalletActivationForm()"
              (defaultBalanceChange)="setDefaultCurrency($event)"
            ></kt-wallet-status>
          </div>
          <div class="col-lg-4 col-md-12 col-12">
            @if (canViewBalance) {
              <kt-wallet-status
                [title]="'PAYLATER LIMIT'"
                [description]=""
                [tag]="'PAYLATER'"
                [canViewBalance]="canViewBalance"
                [selectedOffice]="selectedOffice"
                [status]="WalletTypeEnum.INACTIVE"
                titleToolTipMessage="The ‘’Credit Balance’’ corresponds to the available funds that you can borrow to make a booking."
                titleToolTipPlacement="right-end"
                [showActivateButton]="false"
                [showAddWalletButton]="true"
                [walletDetails]="walletDetailsPaylater"
                [isPageReady]="isPageReady"
                (showWalletActivationForm)="showWalletActivationForm()"
              ></kt-wallet-status>
            }
          </div>
          <div class="col-lg-4 col-md-12 col-12">
            <kt-latest-transactions></kt-latest-transactions>
          </div>
        </div>
      }
      @if (showActivationForm) {
        <div class="col-12 col-lg-6 bg-white">
          <kt-wallet-activation-form></kt-wallet-activation-form>
        </div>
      }
    </div>
  </section>
}
@if (walletLoader) {
  <div class="kt-splash-screen bg-white">
    <div class="section--white">
      <div class="loader--roller">
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
        <div class="blue-theme-loader-point"></div>
      </div>
    </div>
  </div>
}
